import { gql } from "@apollo/client";

import { linkedCasePropertyValueFragment } from "./LinkedCasePropertyValueFragment";

export const linkedCaseElementFragment = gql`
  fragment LinkedCaseElementFragment on Element {
    id
    name
    typeCode
    schemaElement {
      name
      code
    }
    configurableType {
      name
      code
    }
    properties {
      ...LinkedCasePropertyValueFragment
    }
  }
  ${linkedCasePropertyValueFragment}
`;
